import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "api";
import { enAU } from "date-fns/locale";
import { Outlet } from "react-router-dom";
import { THEME } from "./style";

// Initialize Sentry for non-development environments
if (process.env.NODE_ENV !== "development" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    // Capture 10% of the sessions for performance monitoring
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
  });
}

export const App = () => {
  const content = (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={THEME}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={enAU}
          localeText={{ todayButtonLabel: "Now" }}
        >
          <CssBaseline />
          <Outlet />
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );

  if (process.env.NODE_ENV !== "development") {
    return (
      <Sentry.ErrorBoundary fallback={<div>Oops, something went wrong</div>}>
        {content}
      </Sentry.ErrorBoundary>
    );
  }

  return content;
};
